<script>
  export default {
    name: 'submission-status-label',
    props: ['statusKey', 'statusName'],
    computed: {
      labelType: function () {
        /* eslint-disable no-duplicate-case */
        switch (this.statusKey) {
          case 'nao_designado':
            return 'gray'
          case 'aceito':
          case 'atribuido':
          case 'notificado':
          case 'aprovado_pela_triagem':
          case 'em_avaliacao':
            return 'warning'
          case 'reprovado_pela_triagem':
          case 'reprovado':
            return 'danger'
          case 'avaliado':
          case 'publicado':
          case 'finalizado':
          case 'aguardando_publicacao':
            return 'success'
          default:
            return 'gray'
        }
      }
    }
  }
</script>

<template>
    <el-tag :type="labelType">{{statusName}}</el-tag>
</template>

<style>
    .el-tag {
        padding: 4px 10px;
        height: 24px;
        line-height: 15px;
    }
</style>
